module.exports = __webpack_public_path__ + "media/images/flags/4x3/cpv-771a63e88e157c82c45aba8407cc845a.svg";